module.exports = __webpack_public_path__ + "static/media/5.ea936784.png";